/* ============
 * EXCISE DUTIES Module State
 * ============
 */

export default {
  all: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/additionalCode/state.js